/**
 * @generated SignedSource<<609e007ba800da7646dfdc36188c2dbd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Ordering = "ASC" | "ASC_NULLS_FIRST" | "ASC_NULLS_LAST" | "DESC" | "DESC_NULLS_FIRST" | "DESC_NULLS_LAST" | "%future added value";
export type MATPremiumApplyHistoryFilter = {
  AND?: MATPremiumApplyHistoryFilter | null;
  NOT?: MATPremiumApplyHistoryFilter | null;
  OR?: MATPremiumApplyHistoryFilter | null;
  distinct?: boolean | null;
  id?: string | null;
  id_Exact?: string | null;
  id_In?: ReadonlyArray<string> | null;
  id_Not_In?: ReadonlyArray<string> | null;
  isValid?: boolean | null;
  userId_Exact?: string | null;
};
export type MATPremiumApplyHistoryOrder = {
  endAt?: Ordering | null;
};
export type MathKingUserId_premiumsQuery$variables = {
  after?: string | null;
  filters?: MATPremiumApplyHistoryFilter | null;
  first?: number | null;
  order?: MATPremiumApplyHistoryOrder | null;
};
export type MathKingUserId_premiumsQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PremiumPaginator_query">;
};
export type MathKingUserId_premiumsQuery = {
  response: MathKingUserId_premiumsQuery$data;
  variables: MathKingUserId_premiumsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filters"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "order"
},
v4 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "filters",
    "variableName": "filters"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "order",
    "variableName": "order"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "MathKingUserId_premiumsQuery",
    "selections": [
      {
        "args": (v4/*: any*/),
        "kind": "FragmentSpread",
        "name": "PremiumPaginator_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "MathKingUserId_premiumsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "MATPremiumApplyHistoryConnection",
        "kind": "LinkedField",
        "name": "premiums",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MATPremiumApplyHistoryEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MATPremiumApplyHistory",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "startAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MATInternalItem",
                    "kind": "LinkedField",
                    "name": "item",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "premiumType",
                        "storageKey": null
                      },
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v4/*: any*/),
        "filters": [
          "filters",
          "order"
        ],
        "handle": "connection",
        "key": "PremiumPaginator_query_premiums",
        "kind": "LinkedHandle",
        "name": "premiums"
      }
    ]
  },
  "params": {
    "cacheID": "77f5d266e1cae7f67892d61d8d513e29",
    "id": null,
    "metadata": {},
    "name": "MathKingUserId_premiumsQuery",
    "operationKind": "query",
    "text": "query MathKingUserId_premiumsQuery(\n  $filters: MATPremiumApplyHistoryFilter\n  $order: MATPremiumApplyHistoryOrder\n  $first: Int\n  $after: String\n) {\n  ...PremiumPaginator_query_2rfEMg\n}\n\nfragment PremiumConnectionDataTable_PremiumApplyHistoryConnection on MATPremiumApplyHistoryConnection {\n  edges {\n    node {\n      id\n      startAt\n      endAt\n      item {\n        name\n        premiumType\n        id\n      }\n      ...PremiumUpdateDialog_premium\n      ...PremiumDeleteConfirmButton_premium\n    }\n  }\n}\n\nfragment PremiumDeleteConfirmButton_premium on MATPremiumApplyHistory {\n  id\n}\n\nfragment PremiumPaginator_query_2rfEMg on Query {\n  premiums(filters: $filters, order: $order, first: $first, after: $after) {\n    totalCount\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n    edges {\n      node {\n        id\n        startAt\n        endAt\n        item {\n          name\n          premiumType\n          id\n        }\n        __typename\n      }\n      cursor\n    }\n    ...PremiumConnectionDataTable_PremiumApplyHistoryConnection\n  }\n}\n\nfragment PremiumUpdateDialog_premium on MATPremiumApplyHistory {\n  id\n  startAt\n  endAt\n}\n"
  }
};
})();

(node as any).hash = "3ee3ed94a4da4d092b2663d796437f8d";

export default node;
